import { Box, Text, VStack, useColorMode, IconButton, HStack } from "@chakra-ui/react";
import React from "react";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import "../App.css";

const Footer = () => {
  const { colorMode } = useColorMode();

  return (
    <Box
      minH={"48"}
      px={"16"}
      py={["16", "8"]}
      bg={colorMode === "light" ? "white" : "dark"}
    >
      <hr style={{ marginBottom: "60px"}} />
      <VStack direction={["column", "row"]} h={"full"} alignItems={"center"}>
        <Text fontFamily={"Roboto sans-serif"} fontSize={"40px"} fontWeight={"bold"} letterSpacing={"widest"}>
          Follow me
        </Text>
        <HStack spacing={8} mt="1rem" mb="1rem"> {/* Add margin to buttons */}
          <IconButton
            as="a"
            href="https://github.com/himanshugoldy"
            aria-label="GitHub"
            icon={<FaGithub />}
            colorScheme="purple"
            size="lg" // Increase button size
            transition="transform 0.3s"
            _hover={{ transform: "scale(1.1)" }}
          />
          <IconButton
            as="a"
            href="https://www.linkedin.com/in/himanshu-choudhary-443774111/"
            aria-label="LinkedIn"
            icon={<FaLinkedin />}
            colorScheme="purple"
            size="lg" // Increase button size
            transition="transform 0.3s"
            _hover={{ transform: "scale(1.1)" }}
          />
          <IconButton
            as="a"
            href="https://www.instagram.com/"
            aria-label="Instagram"
            icon={<FaInstagram />}
            colorScheme="purple"
            size="lg" // Increase button size
            transition="transform 0.3s"
            _hover={{ transform: "scale(1.1)" }}
          />
        </HStack>
        <Text
          fontSize={"lg"}
          letterSpacing={"widest"}
          textAlign={["center", "left"]}
          fontFamily={"Roboto sans-serif"}
        >
          © Made with ❤️ by HIMANSHU
        </Text>
      </VStack>
    </Box>
  );
};

export default Footer;
